import React, { createContext, useState } from 'react';
import ConfirmationModal from '../../components/UI/ConfirmationModal/ConfirmationModal';

export const ConfirmationModalContext = createContext();

export const ConfirmationModalProvider = ({ children }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [onConfirm, setOnConfirm] = useState(() => () => {});
  const [modalProps, setModalProps] = useState({});

  const showModal = (confirmAction, props = {}) => {
    setIsModalVisible(true);
    setOnConfirm(() => confirmAction);
    setModalProps(props);
  };

  const hideModal = () => {
    setIsModalVisible(false);
  };

  return (
    <ConfirmationModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <ConfirmationModal
        show={isModalVisible}
        onHide={hideModal}
        onConfirm={() => {
          onConfirm();
          hideModal();
        }}
        {...modalProps}
      />
    </ConfirmationModalContext.Provider>
  );
};
